import { apiService } from './apiService';
import { invalidateBootstrapLookups } from './bootstrapService';
import { lookupService } from './lookupService';

export interface Location {
  id: number;
  name: string;
  code: string;
  description?: string;
  address?: string;
  phone?: string;
  email?: string;
  is_active: boolean;
  is_warehouse?: boolean;  // Deprecated: kept for backward compatibility
  location_type?: 'STORE' | 'WAREHOUSE' | 'GENERAL' | 'HOTELS' | 'RESTAURANT';
  created_at?: string;
  updated_at?: string;
}

export interface LocationCreate {
  name: string;
  code: string;
  description?: string;
  address?: string;
  phone?: string;
  email?: string;
  is_warehouse?: boolean;
}

export interface LocationUpdate {
  name?: string;
  code?: string;
  description?: string;
  address?: string;
  phone?: string;
  email?: string;
  is_warehouse?: boolean;  // Deprecated: kept for backward compatibility
  location_type?: 'STORE' | 'WAREHOUSE' | 'GENERAL' | 'HOTELS' | 'RESTAURANT';
  is_active?: boolean;
}

export interface LocationInventorySummary {
  location_id: number;
  location_name: string;
  total_products: number;
  total_quantity: number;
  available_quantity: number;
  committed_quantity: number;
  low_stock_products: number;
  zero_stock_products: number;
}

export const locationService = {
  // Get all locations
  async getLocations(params?: {
    skip?: number;
    limit?: number;
    active_only?: boolean;
    is_active?: boolean;
    search?: string;
    is_warehouse?: boolean;
    forceRefresh?: boolean;
  }): Promise<Location[]> {
    return lookupService.getLocations(params) as Promise<Location[]>;
  },

  // Get location by ID
  async getLocation(id: number): Promise<Location> {
    return apiService.get<Location>(`/locations/${id}`);
  },

  // Create location
  async createLocation(data: LocationCreate): Promise<Location> {
    const created = await apiService.post<Location>('/locations/', data);
    invalidateBootstrapLookups();
    return created;
  },

  // Update location
  async updateLocation(id: number, data: LocationUpdate): Promise<Location> {
    const updated = await apiService.put<Location>(`/locations/${id}`, data);
    invalidateBootstrapLookups();
    return updated;
  },

  // Deactivate location
  async deactivateLocation(id: number): Promise<{ message: string }> {
    const result = await apiService.delete<{ message: string }>(`/locations/${id}`);
    invalidateBootstrapLookups();
    return result;
  },

  // Get location users
  async getLocationUsers(id: number, params?: {
    skip?: number;
    limit?: number;
    active_only?: boolean;
  }): Promise<any[]> {
    return apiService.get<any[]>(`/locations/${id}/users`, params);
  },

  // Get location inventory summary
  async getLocationInventorySummary(id: number): Promise<LocationInventorySummary> {
    return apiService.get<LocationInventorySummary>(`/locations/${id}/inventory-summary`);
  },
};

export default locationService;
